import type { EcosystemAdminEntry } from '@frontend/types';

export interface DownstreamOrphan {
  projectId: string;
  name: string;
  description?: string;
  public?: boolean;
  openprojectNumericId?: number | null;
  openprojectUrl?: string;
}

export interface OrphansListResponse {
  orphans: DownstreamOrphan[];
  count: number;
}

export interface OrphanImportResponse {
  imported: boolean;
  project: {
    id: string;
    ecosystemId: string;
    name: string;
  };
  reconcileRequested?: boolean;
  reconcileUrl?: string;
}

async function adminFetch<T>(method: string, path: string, token: string, body?: unknown): Promise<T> {
  const res = await fetch(path, {
    method,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });
  const data = (await res.json().catch(() => ({}))) as T & { message?: string; code?: string };
  if (!res.ok) {
    throw new Error(data.message || `Request failed: ${res.status}`);
  }
  return data;
}

export function fetchDownstreamOrphans(token: string): Promise<OrphansListResponse> {
  return adminFetch('GET', '/api/admin/projects/orphans', token);
}

export function importDownstreamOrphan(
  token: string,
  payload: { projectId: string; ecosystemId: string; reconcile?: boolean }
): Promise<OrphanImportResponse> {
  return adminFetch('POST', '/api/admin/projects/orphans/import', token, payload);
}

export type { EcosystemAdminEntry };
